import React from "react";

class Progressbar extends React.Component {
  render = () => {
    let { resultModel } = this.props;
    let percentage = (resultModel.right / resultModel.total) * 100;
    return (
      <div style={{ marginBottom: "3rem" }}>
        <div>
          <div style={{ float: "right", fontSize: "14px" }}>
            {resultModel.title}
          </div>
          <div style={{ float: "left", fontSize: "14px" }}>
            ({resultModel.right + "/" + resultModel.total})
          </div>
          <div style={{ clear: "both" }}></div>
        </div>

        <div
          style={{
            width: "100%",
            height: "10px",
            background: "lightgray",
            borderRadius: "5px",
          }}
        >
          <div
            style={{
              width: percentage > 0 ? percentage + "%" : "0px",
              height: "100%",
              background: "#9b7bbb",
              borderRadius: "5px",
            }}
          ></div>
        </div>
      </div>
    );
  };
}

export default Progressbar;
